<template>
  <div class="simulation">
    <Sidebar />
    <div class="simulation-main">
      <SponsorsSimulation />
      <CommunityMember />
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue'
import SponsorsSimulation from '@/components/SponsorsSimulation.vue'
import CommunityMember from '@/components/CommunityMember.vue'

export default {
  name: 'Simulation',
  components: {
    Sidebar,
    SponsorsSimulation,
    CommunityMember,
  }
}
</script>
